"use client";

import { useTranslations } from "next-intl";
import { metadata } from "@/data";
import Image from "next/image";

import { useAbout } from '@/context/about';

import { Paragraph } from "@/components/ui/paragraph";
import { ButtonDown } from "@/components/ui/button-down";
import { Title } from "@/components/ui/title";

const HEADER_IMAGE = "/images/header-photo.png";

function HeaderContent() {
  const t = useTranslations('Header');
  const g = useTranslations('General');
  const { isOpen, toggle } = useAbout();

  const handleClick = () => {
    toggle();
    setTimeout(() => {
      const aboutSection = document.getElementById('about');
      if (aboutSection) {
        aboutSection.scrollIntoView({ behavior: 'smooth' });
      }
    }, 100);
  };

  return (
    <div className="border-bottom-default">
      <div className="container block md:flex gap-2 justify-between min-h-[0] md:min-h-[350px] border-side-default">
        <div className="flex flex-1 flex-col justify-start md:justify-center items-center gap-4">
          <div className="py-8 md:py-2">
            <Title className="mb-2 text-balance">
              {t('title')} <strong>{metadata.site.name}.</strong>
            </Title>
            <Paragraph className="max-w-full md:max-w-[80%] text-balance">
              {t('description')}
            </Paragraph>
            <ButtonDown variant={isOpen ? 'inverted' : 'default'} onClick={handleClick}>
              {isOpen ? g('viewLess') : g('viewMore')}
            </ButtonDown>
          </div>
        </div>
        <div className="flex basis-[45%] items-end justify-start md:justify-center">
          <Image
            src={HEADER_IMAGE}
            className="object-cover aspect-[448/361] w-full h-auto max-w-[250px] md:max-w-[400px]"
            alt={metadata.site.name}
            width={448}
            height={361}
            sizes="(max-width: 768px) 250px, 400px"
            priority
          />
        </div>
      </div>
    </div>
  );
}

export default HeaderContent;
